import { useRegulatoryTrainingMatrix } from '@/hooks/useNewRegulatoryTrainingMatrix';
import ExpandableSubtitle from './ExpandableSubtitle';
import { NewRegulatoryTrainingLinkIndicator } from './NewRegulatoryTrainingLinkIndicator';

export const NewRegulatoryTrainingLinkIndicators = () => {
	const {
		indicators: { data: indicators, isLoading: isLoadingIndicators },
		filters: { actualFilters, setActualFilters },
	} = useRegulatoryTrainingMatrix();
	return (
		<ExpandableSubtitle subtitle={'Indicadores'} className="">
			<div className="flex gap-4">
				<NewRegulatoryTrainingLinkIndicator
					type="totalTrainings"
					value={indicators?.totalTrainings}
					isLoading={isLoadingIndicators}
				/>
				<NewRegulatoryTrainingLinkIndicator
					type="unmappedPositions"
					value={indicators?.unmappedPositions}
					isLoading={isLoadingIndicators}
					selected={actualFilters.onlyUnmappedPositions}
					onClick={() => {
						setActualFilters({
							...actualFilters,
							onlyUnmappedPositions: !actualFilters.onlyUnmappedPositions,
							onlyUnmappedTrainings: false,
						});
					}}
				/>
				<NewRegulatoryTrainingLinkIndicator
					type="unmappedTrainings"
					value={indicators?.unmappedTrainings}
					isLoading={isLoadingIndicators}
					selected={actualFilters.onlyUnmappedTrainings}
					onClick={() => {
						setActualFilters({
							...actualFilters,
							onlyUnmappedTrainings: !actualFilters.onlyUnmappedTrainings,
							onlyUnmappedPositions: false,
						});
					}}
				/>
			</div>
		</ExpandableSubtitle>
	);
};
